"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./css/fontawesome.min.css");

require("./css/brands.min.css");

require("./css/light.min.css");

require("./css/regular.min.css");

require("./css/solid.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FontAwesomeCollection = function FontAwesomeCollection() {
  return _react2.default.createElement("div", null);
};

exports.default = FontAwesomeCollection;

//# sourceMappingURL=FontAwesome.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.font-awesome-collection/dist/FontAwesome.js
// module id = 432
// module chunks = 0